








































































































































































































import Component from 'vue-class-component'
import BaseError from './BaseError'
import {from, interval} from 'rxjs'
import axios, {AxiosResponse} from 'axios'
import {retry, switchMap, takeWhile} from 'rxjs/operators'

const HEART_BEAT_INTERVAL_IN_SECONDS = 5
const isServerAliveObservable = interval(HEART_BEAT_INTERVAL_IN_SECONDS * 1000)
    .pipe(
        switchMap(() => from(axios.get(`${process.env.VUE_APP_ROOT_API}/system/test`))),
        retry(),
        takeWhile((response: AxiosResponse) => !!response && !!response.status)
    )

@Component({
    subscriptions: {
        isServerAlive$: isServerAliveObservable
    }
})
export default class MaintenanceErrorComponent extends BaseError {

    mounted() {
        this.$subscribeTo(isServerAliveObservable, () => this.goToLogin())
    }
}
